/* eslint-disable */
export default {
  mute: 'Désactiver le micro',
  unmute: 'Réactiver le micro',
  hangup: 'Raccrocher',
  reject: 'Rejeter',
  hold: 'Mettre en attente',
  onHold: 'En attente',
  transfer: 'Transférer',
  more: 'Plus',
  stopRecord: 'Arrêter d’enregistrer',
  record: 'Enregistrer',
  showKeypad: 'Clavier',
  hideKeypad: 'Cacher le clavier',
  unHold: 'Reprendre l’appel',
  forward: 'Renvoyer',
  ignore: 'Ignorer',
  voicemail: 'Vers la messagerie vocale',
  custom: 'Personnaliser',
  answerAndEnd: 'Rép et racc.',
  answerAndHold: 'Répondre et mettre en attente',
  answer: 'Répondre',
  completeTransfer: 'Effectuer le transfert',
  reply: 'Répondre',
  add: 'Ajouter',
  mergeCall: 'Fusionner avec l’appel actif',
  endCallForEveryone: 'Terminer l’appel pour tous les utilisateurs',
  leaveCall: 'Quitter l’appel',
  leaveOrEndCall: 'Quitter ou terminer l’appel ?',
} as const;

// @key: @#@"mute"@#@ @source: @#@"Mute"@#@
// @key: @#@"unmute"@#@ @source: @#@"Unmute"@#@
// @key: @#@"hangup"@#@ @source: @#@"Hang up"@#@
// @key: @#@"reject"@#@ @source: @#@"Reject"@#@
// @key: @#@"hold"@#@ @source: @#@"Hold"@#@
// @key: @#@"onHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"more"@#@ @source: @#@"More"@#@
// @key: @#@"stopRecord"@#@ @source: @#@"Stop Recording"@#@
// @key: @#@"record"@#@ @source: @#@"Record"@#@
// @key: @#@"showKeypad"@#@ @source: @#@"Keypad"@#@
// @key: @#@"hideKeypad"@#@ @source: @#@"Hide Keypad"@#@
// @key: @#@"unHold"@#@ @source: @#@"Unhold"@#@
// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"voicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"answerAndEnd"@#@ @source: @#@"Answer & End"@#@
// @key: @#@"answerAndHold"@#@ @source: @#@"Answer & Hold"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"completeTransfer"@#@ @source: @#@"Complete transfer"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"mergeCall"@#@ @source: @#@"Merge with active call"@#@
// @key: @#@"endCallForEveryone"@#@ @source: @#@"End call for everyone"@#@
// @key: @#@"leaveCall"@#@ @source: @#@"Leave call"@#@
// @key: @#@"leaveOrEndCall"@#@ @source: @#@"Leave or end call?"@#@
